'use strict';

// jQuery is for monkeys.
// const $ = require('jquery');
// window.jQuery = $;
// window.$ = $;

// Lodash
import _ from 'lodash'
window._ = _
Vue.prototype._ = _

// Base
import Vue from 'vue'

// Component file
import OnlineRentalPage from '@/vue/online-rental/OnlineRentalPage'

// Axios
import axios from 'axios'
window.axios = axios
window.axios.defaults.headers['Accept'] = 'application/json' // Axios header default

// Momentjs
import moment from 'moment'
window.moment = moment
Vue.prototype.moment = moment
moment.locale('nl')

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
// Solid
import { faFile, faPen, faCheck, faInfoCircle, faArrowUp, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
// Regular
// import { faPenSquare } from '@fortawesome/free-regular-svg-icons'
// Add
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faFile, faPen, faCheck, faInfoCircle, faArrowUp, faExclamationCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Global components
// import FullPageLoader from '@/vue/FullPageLoader.vue'
// Vue.component('FullPageLoader', FullPageLoader)
// import InvoiceStatus from '@/vue/invoices/components/InvoiceStatus.vue'
// Vue.component('InvoiceStatus', InvoiceStatus)
import SlideUpDown from 'vue-slide-up-down'
Vue.component('slide-up-down', SlideUpDown)

// Buefy
import Buefy from 'buefy'
Vue.use(Buefy, {
    defaultIconComponent: 'font-awesome-icon',
    defaultIconPack: 'fa',
    // General
    defaultDialogConfirmText: 'Bevestigen',
    defaultDialogCancelText: 'Annuleren',
    defaultSnackbarPosition: 'is-top-right',
    // Dates
    defaultDayNames: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    defaultMonthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    defaultFirstDayOfWeek: 1,
    // defaultDateFormatter: date => date.toLocaleDateString('nl-NL')
})

// [✅] Production settings.
if(process.env.NODE_ENV == 'development'){
    console.log('[💡] Application is in development mode!')
    Vue.config.productionTip = false
} else if(process.env.NODE_ENV == 'production') {
    console.log('[💡] Application is in production mode!')
    Vue.config.productionTip = false
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
} else {
    console.error('[❌] Unknown NODE_ENV!')
}

const settings = document.querySelector('#app').getAttribute('data-settings')
const records = document.querySelector('#app').getAttribute('data-records')
const organisation = document.querySelector('#app').getAttribute('data-organisation')
const closed = !!document.querySelector('#app').getAttribute('data-closed')

window.onload = function () {
    new Vue({
        el: '#app',
        render: h => h(OnlineRentalPage),
        data: {
            settings,
            records,
            organisation,
            closed
        }
    })
}